import flex from '../../styles/flex';
import fonts from '../../styles/fonts';
import palette from '../../styles/palette';
import position from '../../styles/position';

const styles = {
    wrapper: position.absoluteFill,
    logo: {
        maxWidth: 200
    } as React.CSSProperties,
    centeredBox: {
        ...flex.flexColumns,
        textAlign: "center",
        justifyContent: "center",
        alignItems: "center",
        height: "100%"
    } as React.CSSProperties,
    centeredBoxInner: {
        padding: 50
    } as React.CSSProperties,
    title: {
        ...fonts.title,
        color: palette.text.secondary,
    } as React.CSSProperties,
    message: {
        ...fonts.subTitle,
        color: palette.text.secondary,
        textTransform: 'capitalize',
    } as React.CSSProperties,
};
export default styles;
